import {Banner} from '@wandb/components';
import React from 'react';
import {useLocation} from 'react-router-dom';

import {urlPrefixed} from '../config';
import {useHasLocalLicenseQuery} from '../generated/graphql';
import {
  createDismissibleBanner,
  DEFAULT_BANNER_SHOW_AFTER,
} from '../pages/Billing/AccountSettings/WarningBanner/DismissibleBanner';
import {LOGIN_PATH} from '../routes/auth/authPaths';
import {ONBOARDING_FLOW_PATH} from '../routes/onboarding/onboardingPaths';

const LOCAL_LICENSE_NUDGE_BANNER_ID = 'local-license-nudge';

const GetLicenseNudgeBarBanner = createDismissibleBanner<{}>({
  id: () => LOCAL_LICENSE_NUDGE_BANNER_ID,
  showAfter: DEFAULT_BANNER_SHOW_AFTER,
  Component: ({onDismiss}) => (
    <Banner
      variant="global"
      isDismissible
      isVisible
      onDismiss={async () => {
        window.analytics?.track('License Nudge Dismissed');
        await onDismiss();
      }}
      aria-label="License required for W&B Local">
      <Banner.Body>
        You need a license for this instance of W&B Local
      </Banner.Body>
      <Banner.Action
        href="https://api.wandb.ai/deploy/redirect/unlicensed"
        onPress={() => {
          window.analytics?.track('Get License Clicked');
        }}>
        Get a free license
      </Banner.Action>
      <Banner.Action
        href={urlPrefixed('/system-admin', false)}
        onPress={() => {
          window.analytics?.track('Add License Clicked');
        }}>
        Add license
      </Banner.Action>
    </Banner>
  ),
});

export const GetLicenseNudgeBar: React.FC = React.memo(() => {
  const {data, loading} = useHasLocalLicenseQuery();

  const location = useLocation();

  if (
    loading ||
    data?.serverInfo?.hasLocalLicense ||
    ['/', LOGIN_PATH, ONBOARDING_FLOW_PATH].includes(location.pathname)
  ) {
    return null;
  }
  return <GetLicenseNudgeBarBanner />;
});
